import React, { useState } from 'react';
import './ContactPage.css';

function ContactPage() {
  const [copySuccess, setCopySuccess] = useState({ email: false, phone: false });

  const copyToClipboard = async (text, type) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopySuccess(prev => ({ ...prev, [type]: true }));
      setTimeout(() => {
        setCopySuccess(prev => ({ ...prev, [type]: false }));
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className="contact-page">
      {/* Header */}
      <header className="contact-header">
        <nav className="contact-nav">
          <a href="/" className="contact-logo">Clear&Bare</a>
          <ul className="contact-nav-links">
            <li><a href="/">Home</a></li>
            <li><a href="/shop">Shop</a></li>
            <li><a href="/legal">Legal</a></li>
          </ul>
        </nav>
      </header>

      {/* Main Content */}
      <div className="contact-container">
        <h1 className="contact-page-title">Contact us</h1>
        <p className="contact-page-subtitle">
          Looking to contact Clear&Bare? There's a few ways to do it based on your inquiry—check out all your options below.
        </p>

        {/* Business Information */}
        <div className="business-info">
          <h3>Authorized Business Entity</h3>
          <p className="business-name">CLEAR & BARE</p>
        </div>

        {/* Contact Methods */}
        <div className="contact-methods">
          {/* Email Card */}
          <div className="contact-card">
            <div className="contact-icon">📧</div>
            <h3>Email Us</h3>
            <div className="contact-info">
              clearandbare.skincare@gmail.com
            </div>
            {/* <div>
              <a 
                href="mailto:clearandbare.skincare@gmail.com?subject=Inquiry from Clear&Bare Website" 
                className="contact-button"
              >
                Send Email
              </a>
              <button 
                onClick={() => copyToClipboard('clearandbare.skincare@gmail.com', 'email')}
                className="copy-button"
              >
                Copy Email
              </button>
              <div className={`copy-success ${copySuccess.email ? 'show' : ''}`}>
                Email copied to clipboard!
              </div>
            </div> */}
          </div>

          {/* Phone Card */}
          <div className="contact-card">
            <div className="contact-icon">📞</div>
            <h3>Call Us</h3>
            <div className="contact-info">
              +91 8788631381
            </div>
            {/* <div>
              <a 
                href="tel:+918788631381" 
                className="contact-button"
              >
                Call Now
              </a>
              <button 
                onClick={() => copyToClipboard('+91 8788631381', 'phone')}
                className="copy-button"
              >
                Copy Number
              </button>
              <div className={`copy-success ${copySuccess.phone ? 'show' : ''}`}>
                Phone number copied to clipboard!
              </div>
            </div> */}
          </div>
        </div>

        {/* Business Hours */}
        <div className="business-hours">
          <h3>Business Hours & Response Time</h3>
          <div className="hours-info">Monday - Saturday: 9:00 AM - 6:00 PM IST</div>
          <div className="hours-info">Sunday: Closed</div>
          <div className="response-time">We typically respond within 24 hours</div>
        </div>

        {/* Address Information */}
        <div className="business-info">
          <h3>Registered Office</h3>
          <p style={{ margin: 0, color: '#666666', fontSize: '1.1rem' }}>
            Central Hanuman Road<br />
            Beed, Maharashtra 431515<br />
            India
          </p>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;